import { aanpAuthOptions } from "./util";
import { apiUrl } from "../config";
import instance from "./instance";

export function getConferenceFees(registrationMembershipType, joinRenewMembershipType,  promoCode) {	
	return instance.get(`${apiUrl}/conferenceFee?registrationMembershipType=${registrationMembershipType}&joinRenewMembershipType=${joinRenewMembershipType}&promoCode=${promoCode}`, aanpAuthOptions()).then(r => r.data);	
}
